import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { SystemService } from 'src/app/service/system.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-personal-interview',
  templateUrl: './personal-interview.component.html',
  styleUrls: ['./personal-interview.component.scss']
})
export class PersonalInterviewComponent implements OnInit {
  currentDate = new Date();
  showLoader: boolean = false;
  creating: boolean = false;
  url: string = "";
  imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  uploadImage: any;
  countries: any;
  regions: any;
  provinces: any;
  city: any;
  maritalStatus: any;
  milStatus: any;
  appStatusPersonalInterview: any = 40;
  candId: any;
  candNameEn: any;
  candNameAr: any;
  candNatId: any;
  candCode: any;
  link = "";
  photoPath: any = "assets/images/stud-image.png";
  candStatus:any;
  personalInterviewData = new FormGroup({
    candCode: new FormControl(''),
    commentRubricScore: new FormControl('', [
      //Validators.required,
    ]),
    currentDate: new FormControl(new Date().toLocaleDateString(), [
      // Validators.required,
    ]),
    interviewComment: new FormControl('', [
     // Validators.required,
    ]),
    attitudeRubricScore: new FormControl('', [
     // Validators.required,
    ]),
    attitudeComment: new FormControl('', [
     // Validators.required,
    ]),
    interviewVideoLink: new FormControl('', [
      //Validators.required,
    ]),
    writingRubricScore: new FormControl('', [
      //Validators.required,
    ]),
    interviewWritingComment: new FormControl('', [
     // Validators.required,
    ]),
  });
  constructor(private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router,
    private systemService: SystemService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.candId = params['candId'] || "";

        if (this.candId != "") {
          this.getCandById(this.candId);
        } else {

          this.toastr.warning(this.translate.instant('NOT_FOUND'));
          this.router.navigate(['/admission/candidate-inquiry']);
        }
      });
  }
  getCandById(candId: number) {
    this.admService.getCandidateById(candId).subscribe(
      data => {
        this.personalInterviewData.controls.candCode.setValue(data.candCode);
        this.candNameEn = data.fullNameEn;
        this.candNameAr = data.fullNameAr;
        this.candNatId = data.nidNo;
        this.candCode = data.candCode;
        this.candStatus=data.appstatusid;
        this.photoPath = `${environment.API_URL_UTIL}/api/downloadFile/${data.photoFilename}`;
        ///////////////////////
        this.personalInterviewData.controls.commentRubricScore.setValue(data.interviewRscore); // interviewRscore
        this.personalInterviewData.controls.interviewComment.setValue(data.interviewComment);//interviewComment
        this.personalInterviewData.controls.attitudeRubricScore.setValue(data.attitudeRscore);// attitudeRscore
        this.personalInterviewData.controls.attitudeComment.setValue(data.attitudeComment);//attitudeComment
        this.personalInterviewData.controls.interviewVideoLink.setValue(data.interviewVduLink);//interviewVduLink
        this.personalInterviewData.controls.writingRubricScore.setValue(data.interviewWritingRscore);//interviewVduLink
        this.personalInterviewData.controls.interviewWritingComment.setValue(data.interviewWritingComment);//interviewVduLink
        this.link = data.interviewVduLink;
        if (data.interviewDate !== null && data.interviewDate.length > 0) {
          let interViewDate = new Date(data.interviewDate)
          this.personalInterviewData.controls.currentDate.setValue(interViewDate.toLocaleDateString());//interviewDate
        }
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  personalInterviewDataSubmit() {
    this.creating = true;
    console.log("befor valid");
    if (this.personalInterviewData.valid) {
      console.log("in valid");
      this.creating = true;
      // this.admService.addPersionalInterViewData(this.candId,
      //   this.personalInterviewData.controls.commentRubricScore.value,
      //   this.personalInterviewData.controls.interviewComment.value,
      //   this.personalInterviewData.controls.attitudeRubricScore.value,
      //   this.personalInterviewData.controls.attitudeComment.value,
      //   this.personalInterviewData.controls.interviewVideoLink.value,
      //   this.currentDate,
      //   this.appStatusPersonalInterview
      // )
      let candStatusUpdate=this.appStatusPersonalInterview;
      if(this.candStatus>=55){
        candStatusUpdate=this.candStatus;
      }
      this.admService.addPersionalInterViewDataAndUsername(this.candId,
        this.personalInterviewData.controls.commentRubricScore.value,
        this.personalInterviewData.controls.interviewComment.value,
        this.personalInterviewData.controls.attitudeRubricScore.value,
        this.personalInterviewData.controls.attitudeComment.value,
        this.personalInterviewData.controls.interviewVideoLink.value,
        this.currentDate,
        candStatusUpdate,
        this.globals.currentUserInfo.username,
        this.personalInterviewData.controls.writingRubricScore.value,
        this.personalInterviewData.controls.interviewWritingComment.value
      )
        .subscribe(
          data => {
            this.router.navigate(['/admission/candidate-inquiry']);
            this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
          },
          error => {
            this.creating = false
            this.toastr.warning(this.translate.instant("CAN_NOT_UPDATE"));
          },
          () => this.creating = false
        );
    }
    else {
      console.log("non valid");
      this.personalInterviewData.markAllAsTouched();
      this.personalInterviewData.markAsDirty();
      this.creating = false;
    }
  }

  personalInterviewChange() {

  }


}
